import {
  ArrivalZoneCreateDto,
  ArrivalZoneEditDto,
  useArrivalZoneApi,
} from "~/api/GeneratedApi";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export const useArrivalZones = ({
  arrivalZoneId,
  selectedPortId,
}: {
  arrivalZoneId?: number | undefined;
  selectedPortId?: number | undefined;
} = {}) => {
  const {
    getArrivalZone,
    getArrivalZones,
    addArrivalZone,
    editArrivalZone,
    getArrivalZonesByPortId,
  } = useArrivalZoneApi();
  const { data: arrivalZone, isLoading: isArrivalZoneLoading } = useCustomQuery(
    { key: "arrival-zone", id: arrivalZoneId },
    () => getArrivalZone(arrivalZoneId!),
    { enabled: !!arrivalZoneId },
  );

  const { data: arrivalZones } = useCustomQuery(
    "arrival-zones",
    () => getArrivalZones(),
    { enabled: !!selectedPortId },
  );

  const { data: arrivalZonesForPort, refetch: refectArrivalZonesForPort } =
    useCustomQuery(
      { key: "arrival-zones-for-port", id: selectedPortId },
      () => getArrivalZonesByPortId(selectedPortId as number), // getArrivalZones({ id: selectedPortId! }),
      { enabled: !!selectedPortId },
    );

  const { mutate: addArrivalZoneMutation } = useCustomMutation(
    (createdArrivalZone: ArrivalZoneCreateDto) =>
      addArrivalZone(createdArrivalZone),
  );

  const { mutate: editArrivalZoneMutation } = useCustomMutation(
    (editedArrivalZone: ArrivalZoneEditDto) =>
      editArrivalZone(editedArrivalZone, arrivalZoneId!),
  );

  return {
    arrivalZone,
    isArrivalZoneLoading,
    arrivalZones,
    addArrivalZoneMutation,
    editArrivalZoneMutation,
    arrivalZonesForPort,
    refectArrivalZonesForPort,
  };
};
